<template>
  <div class="w">
    <h2>Выберите группу</h2>
    <div class="gr">
      <div class="g" v-for="g in groups" :key="g.api" @click="selGroup(g)">
        {{ g.name }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  methods: {
    selGroup(e) {
      console.log(e);
      this.$store.commit("setconf", ["group", e]);
      this.$router.replace("/");
    },
  },
  data() {
    return {
      groups: {},
    };
  },
  mounted() {
    fetch("https://api.jsonbin.io/b/604b3d0e7ffeba41c076f3aa/2")
    .then(e=>e.json())
    .then((e) => {
      this.groups = e;
    });
  },
};
</script>

<style scoped lang='stylus'>
.bubbles {
  display: none !important;
}
.w {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: auto
}

h2 {
  margin: 128px;
  text-align center
}

.gr {
  margin: 24px
}

.g {
  border: 1px solid var(--border);
  padding: 10px;
  border-radius: 7px;
  margin-bottom: 10px;
  text-align: center;
  background: var(--bg-sect)
}
</style>